export const TRADE_LOG_PAGE_UUID = '1dd1a2bd-8e48-4ab5-86f5-85662a2a239f'
